import React from 'react';
import { connect } from 'react-redux';
import { Button, Input, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import API from '../../../../../utils/API';
import { toastSuccess } from '../../../../../utils/toastMessage';
import { getProducts, setProducts } from '../../../../../actions/dishSearch';

const CreateProduct = React.memo(({ onClose, getProducts, setProducts, products }) => {
  const [productName, setProductName] = React.useState('');
  const [isError, setIsError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const onCreateProduct = () => {
    const trimmedProductName = productName.trim();
    if (
      trimmedProductName === '' ||
      trimmedProductName.length < 2 ||
      trimmedProductName.length > 50
    ) {
      setIsError(true);
      return;
    }
    setIsLoading(true);
    API.post(`/product`, {
      name: productName,
    })
      .then((resp) => {
        getProducts();
        toastSuccess('Ингредиент был создан успешно');
        setIsLoading(false);
        onClose();
        setProductName('');
        const newProducts = JSON.parse(JSON.stringify(products));
        newProducts.push(resp.data.data.items);
        setProducts(newProducts); // add new product to list products in the store
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const onChangeName = (e) => {
    if (isError) setIsError(false);
    setProductName(e.target.value);
  };

  return (
    <CreateProductContentBlock>
      <WrapContent>
        <WrapBlock>
          <Header textAlign="center" as="h3">
            Создание ингредиента
          </Header>
        </WrapBlock>
        <WrapBlock>
          <Input
            fluid
            placeholder="Введите название ингредиента"
            onChange={onChangeName}
            value={productName}
            error={isError}
          />
          {isError && (
            <ErrorText>Название ингридиента должно содержать от 2х до 50ти символов</ErrorText>
          )}
        </WrapBlock>
        <WrapButtonBlock>
          <Button fluid color="green" onClick={onCreateProduct} loading={isLoading}>
            Создать ингредиент
          </Button>
        </WrapButtonBlock>
        <WrapButtonBlock>
          <StyledLink to="/dish/create" color="blue">
            На создание блюда
          </StyledLink>
        </WrapButtonBlock>
      </WrapContent>
    </CreateProductContentBlock>
  );
});

const mapStateToProps = (state) => ({
  products: state.dishSearch.products,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (name) => dispatch(getProducts(name)),
  setProducts: (products) => dispatch(setProducts(products)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateProduct);

const WrapContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40%;
`;

const WrapBlock = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
`;

const WrapButtonBlock = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  width: 50%;
`;

const ErrorText = styled.div`
  color: red;
  margin: 5px 0px;
  font-size: 10px;
`;

const CreateProductContentBlock = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const StyledLink = styled(Link)`
  padding: 8px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  background: #2185d0;
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: #1678c2;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/Products/CreateProduct.jsx